import { takeEvery, takeLatest } from 'redux-saga/effects';
import { createHashedTaasData, StreckenTarifierer } from '@ps20-frontend/preis-lib';

import { App } from '@ps20-frontend/frontend-models';
import {
  StreckenTarifierungRequestEvents,
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
} from '@ps20-frontend/shop-integration-redux';
import { TaasUriData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { UnfActions } from '../unfActions';
import { IAppState } from '../appState';
import { buildTaasUnfDataForStrecke } from './transformer/unfData.transformer';

export let streckenTarifierer: StreckenTarifierer<IAppState, TaasUriData>;

const basisTarifererConfig = {
  appId: App.UNF,
  successEventWithInfo: StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_UNF,
  successEventWithoutInfo:
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_UNF,
  errorEvent: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_UNF,
};

export const requestActions = [
  TARIF_CHECKED,
  ZUSATZOPTION_CHECKED,
  ZUSATZOPTION_UNCHECKED,
  UnfActions.ZUSATZOPTIONINPUT_CHANGED,
  UnfActions.ZUSATZOPTION_CHECKED,
  UnfActions.ZUSATZOPTION_UNCHECKED,
  UnfActions.LEISTUNG_EIGENSCHAFT_CHANGED,
  UnfActions.PREISE_REQUESTED,
  UnfActions.SELECTED_INVSUMME_CHANGED,
];

export const successActions = [
  StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_UNF,
  StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_UNF,
];

export function* streckenTarifierungUnf(): Generator<ForkEffect> {
  streckenTarifierer = new StreckenTarifierer(
    basisTarifererConfig,
    buildTaasUnfDataForStrecke,
    null,
    createHashedRelevantRiskdataUnf,
  );

  yield takeLatest(requestActions, safeSaga(streckenTarifierer.callTarifierung, App.UNF));
  yield takeEvery(successActions, safeSaga(streckenTarifierer.handleSuccess, App.UNF));
  yield takeEvery(
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_UNF,
    safeSaga(streckenTarifierer.handleError, App.UNF),
  );
}

export function createHashedRelevantRiskdataUnf(taasData: TaasUriData): string {
  const relevantData = { ...taasData };
  delete relevantData.salesProducts;
  delete relevantData.spartenType;
  return createHashedTaasData(relevantData);
}
